import * as React from 'react';
import {
  IStackTokens,
  Stack,
  TextField,
  FocusZone,
  ChoiceGroup,
  IChoiceGroupOption,
} from '@fluentui/react';
import { FC, useState, useEffect } from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { GeneralAnalytics, GeneralTabValidationInfo } from './AnalyticsModel';
import { ErrorMessage } from 'src/App/Components/Common/ErrorMessage';
import { UATConstants } from 'src/Common/Models/UATConstants';
import 'src/styles/Utility.css';

const options: IChoiceGroupOption[] = [
  {
    key: '0',
    text: 'Private view',
    onRenderField: (props, render) => {
      return (
        <div>
          {render!(props)}
          <div className='generalTab-OptionText'>{UATConstants.AnalyticViewText.privateView}</div>
        </div>
      );
    },
  },
  {
    key: '1',
    text: 'Shared view',
    onRenderField: (props, render) => {
      return (
        <div>
          {render!(props)}
          <div className='generalTab-OptionText'>{UATConstants.AnalyticViewText.sharedView}</div>
        </div>
      );
    },
    styles: { root: { marginTop: 25 } },
  },
];

interface Props {
  generalInput: GeneralAnalytics;
  sendBackToParent: Function;
  validationInfo: any;
}

const GeneralTab: FC<Props> = (props) => {
  const [viewTitle, setTitle] = useState<string>(props.generalInput.title || '');
  const [viewDescription, setDescription] = useState<string>(props.generalInput.description || '');
  const [viewType, setViewType] = useState<number>(props.generalInput.viewType || 0);

  //Validation Object
  const [generalTabValidationInfo, setGeneralTabValidationInfo] =
    useState<GeneralTabValidationInfo>(
      props.validationInfo || {
        titleIsValid: true,
        descrIsValid: true,
      }
    );

  useEffect(() => {
    const gaInput: GeneralAnalytics = {
      title: viewTitle,
      description: viewDescription,
      viewType: viewType,
    };
    props.sendBackToParent(gaInput);
  }, [viewTitle, viewDescription, viewType]);

  const onTitleInfoChange = (fieldName: string, newValue: any) => {
    if (fieldName === '') {
      return;
    }
    setTitle(newValue);
  };

  function _onChange(ev: React.FormEvent<HTMLInputElement>, option: IChoiceGroupOption): void {
    setViewType(parseInt(option.key));
  }

  const onChangeDescValue = React.useCallback(
    (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
      if (!newValue || newValue.length <= 400) {
        setDescription(newValue || '');
      }
    },
    []
  );

  const stackTokens: IStackTokens = { childrenGap: 15 };
  return (
    <>
      <div className='ms-Grid'>
        <div>
          {false && (
            <Spinner
              size={SpinnerSize.large}
              label={UATConstants.PlaceholdersAndTitles.Loading}
              ariaLive='assertive'
              className='loading-panel-full'
            />
          )}
        </div>
        <Stack tokens={stackTokens} className='marginLeft8px'>
          <div>
            <FocusZone>
              <div className='paddingRight30px'>
                <div className='height15'></div>
                <Stack tokens={stackTokens}>
                  <div className='ms-Grid-row'>
                    <div className='ms-Grid-col ms-lg8'>
                      <TextField
                        label={UATConstants.PlaceholdersAndTitles.Name}
                        title={UATConstants.PlaceholdersAndTitles.Name}
                        placeholder={UATConstants.PlaceholdersAndTitles.EnterName}
                        value={viewTitle}
                        onChange={(event: any, newText: string) => {
                          onTitleInfoChange('title', newText);
                        }}
                        required
                      />
                      {!generalTabValidationInfo.titleIsValid && (
                        <ErrorMessage
                          containerClassName='ms-Grid-col ms-Grid-row'
                          onDismiss={() => {
                            const g = generalTabValidationInfo;
                            g.titleIsValid = true;
                            setGeneralTabValidationInfo(g);
                          }}>
                          {UATConstants.ErrorMessages.ViewNameMandatory}
                        </ErrorMessage>
                      )}
                    </div>
                  </div>
                  <div className='ms-Grid-row'>
                    <div className='ms-Grid-col ms-lg8'>
                      <TextField
                        label={UATConstants.PlaceholdersAndTitles.Description}
                        title={UATConstants.PlaceholdersAndTitles.Description}
                        placeholder={UATConstants.PlaceholdersAndTitles.EnterDescription}
                        value={viewDescription}
                        multiline
                        autoAdjustHeight
                        inputClassName='min-height-70'
                        onChange={onChangeDescValue}
                      />
                    </div>
                  </div>

                  <div className='ms-Grid-row'>
                    <div className='ms-Grid-col ms-lg6'>
                      <ChoiceGroup
                        defaultSelectedKey={viewType.toString()}
                        label={UATConstants.PlaceholdersAndTitles.Sharing}
                        required={true}
                        options={options}
                        onChange={_onChange}
                      />
                    </div>
                  </div>
                </Stack>
              </div>
            </FocusZone>
          </div>
          <div className='height30'></div>
        </Stack>
      </div>
    </>
  );
};

export default GeneralTab;
